import React, { createContext, ReactNode, useState } from 'react'

const MedicalViewsInPortuguese = [
  'visao-geral',
  'visao-materno-infantil',
  'visao-laboratorio',
  'visao-radiologia'
] as const
type MedicalViewInPortuguese = (typeof MedicalViewsInPortuguese)[number]

export interface LastSelectedMedicalViewContextProps {
  lastSelectedMedicalView: MedicalViewInPortuguese
  updateLastSelectedMedicalView: (pathname: string) => void
}

const defaultValue = {
  lastSelectedMedicalView: 'visao-geral' as MedicalViewInPortuguese
}

const LastSelectedMedicalViewContext = createContext<LastSelectedMedicalViewContextProps>({
  ...defaultValue
} as LastSelectedMedicalViewContextProps)

interface LastSelectedMedicalViewProviderProps {
  children: ReactNode
}

const LastSelectedMedicalViewProvider = ({ children }: LastSelectedMedicalViewProviderProps): JSX.Element => {
  const [lastSelectedMedicalView, setLastSelectedMedicalView] = useState<MedicalViewInPortuguese>(
    defaultValue.lastSelectedMedicalView
  )

  const extractMedicalViewFrom = (pathname: string): MedicalViewInPortuguese | undefined => {
    const selectedMedicalView = MedicalViewsInPortuguese.find(view => pathname.includes(view))
    return selectedMedicalView
  }

  const updateLastSelectedMedicalView = (pathname: string) => {
    const selectedMedicalView = extractMedicalViewFrom(pathname)
    if (selectedMedicalView) setLastSelectedMedicalView(selectedMedicalView)
  }

  return (
    <LastSelectedMedicalViewContext.Provider value={{ lastSelectedMedicalView, updateLastSelectedMedicalView }}>
      {children}
    </LastSelectedMedicalViewContext.Provider>
  )
}

const useLastSelectedMedicalView = (): LastSelectedMedicalViewContextProps => {
  return React.useContext(LastSelectedMedicalViewContext)
}

export { LastSelectedMedicalViewContext, LastSelectedMedicalViewProvider, useLastSelectedMedicalView }
